/**
 * Constants for all content types
 * @module services/content/content-types
 */
import _includes from 'lodash/includes'

export const CONTENT_TYPE_SERIES = 'series'
export const CONTENT_TYPE_VIDEO = 'video'
export const CONTENT_TYPE_CLIP = 'clip'
export const CONTENT_TYPE_PERSON = 'person'
export const CONTENT_TYPE_ARTICLE = 'article'
export const CONTENT_TYPE_TAG = 'tag'
export const CONTENT_TYPE_GUIDE = 'guide'
export const CONTENT_TYPE_GUIDE_DAY = 'guide-day'
export const CONTENT_TYPE_PROMOTION = 'promotion'
export const CONTENT_TYPE_FAQ = 'faq'
export const CONTENT_TYPE_PRODUCT = 'product'
export const CONTENT_TYPE_BONUS_PACKAGE = 'bonus-package'
export const CONTENT_TYPE_SERVICE = 'service'
export const CONTENT_TYPE_COURSE = 'course'
export const CONTENT_TYPE_COURSE_MODULE = 'course-module'

export const YI_CONTENT_TYPE_YI_COURSE = 'yi-course'
export const YI_CONTENT_TYPE_YI_COURSE_SALES_PAGE = 'yi-course-sales-page'
export const YI_CONTENT_TYPE_YI_SERIES = 'yi-series'
export const YI_CONTENT_TYPE_YI_COURSE_MODULE_GROUP = 'yi-course-module-group'
export const YI_CONTENT_TYPE_YI_COURSE_MODULE = 'yi-course-module'
export const YI_CONTENT_TYPE_YI_MEMBERSHIP_PROMO = 'yi-membership-promo'
export const YI_CONTENT_TYPE_YI_HOMEPAGE_HERO_CONTENT = 'yi-homepage-hero-content'

/**
 * Get an array of all content types
 * @returns {String[]} A list of all content types
 */
export function getAllContentTypes () {
  return [
    CONTENT_TYPE_SERIES,
    CONTENT_TYPE_VIDEO,
    CONTENT_TYPE_CLIP,
    CONTENT_TYPE_PERSON,
    CONTENT_TYPE_ARTICLE,
    CONTENT_TYPE_TAG,
    CONTENT_TYPE_GUIDE,
    CONTENT_TYPE_GUIDE_DAY,
    CONTENT_TYPE_PROMOTION,
    CONTENT_TYPE_FAQ,
    CONTENT_TYPE_PRODUCT,
    CONTENT_TYPE_BONUS_PACKAGE,
    CONTENT_TYPE_SERVICE,
    CONTENT_TYPE_COURSE,
    CONTENT_TYPE_COURSE_MODULE,
  ]
}

/**
 * Returns True if content type is valid
 * @param {String} contentType Name of content type to validate
 */
export function isValidContentType (contentType) {
  return _includes(getAllContentTypes(), contentType)
}
